module.exports = __webpack_public_path__ + "static/media/logo-2.3bf60137.png";